import { AxiosError } from 'axios';
import { functionalActivityApi } from '@/entities/FunctionalActivity';
import { useUserStore } from '@/entities/User';
import { toastError, toastSuccess, useCustomToast } from '@/shared/lib';

export function useFunctionalActivityCreate() {
  const toast = useCustomToast();
  const userStore = useUserStore();

  async function createFunctionalActivity(
    name: string
  ): Promise<{ success: boolean; nameError?: string }> {
    const selectedBranchId = Number(localStorage.getItem('selectedBranchId'));
    const hasValidSelectedBranchId = Number.isFinite(selectedBranchId) && selectedBranchId > 0;
    const normalizedSelectedBranchId = hasValidSelectedBranchId ? selectedBranchId : null;
    const membership = userStore.memberships.find((m) => m.branchId === normalizedSelectedBranchId);
    const branchId =
      membership?.branchId ?? normalizedSelectedBranchId ?? userStore.memberships[0]?.branchId;

    if (!branchId) {
      toastError(toast, 'Não foi possível determinar a filial para a criação da atividade.');
      return { success: false };
    }

    try {
      await functionalActivityApi.create({ name, branchId });
      toastSuccess(toast, 'Atividade criada com sucesso');
      return { success: true };
    } catch (err) {
      if (err instanceof AxiosError && err.response?.data?.errors?.name?.[0]) {
        const nameError = err.response.data.errors.name[0];
        toastError(toast, nameError);
        return { success: false, nameError };
      }
      toastError(toast, 'Erro ao criar Atividade, tente novamente.');
      return { success: false };
    }
  }

  return { createFunctionalActivity };
}
